import { styled } from "@mui/system";
import { Box, Card, IconButton } from "@mui/material";

export const StyledContainer = styled(Card, {
  shouldForwardProp: (prop) => prop !== "backgroundColor",
})<{ backgroundColor: string }>(({ backgroundColor, theme }) => ({
  position: "relative",
  backgroundColor,
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
  },
}));

export const StyledContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  [theme.breakpoints.up("lg")]: {
    flexDirection: "row",
  },
}));

export const StyledImage = styled("img")(({ theme }) => ({
  maxWidth: 220,
  [theme.breakpoints.up("lg")]: {
    width: "auto",
  },
}));

export const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(2),
  right: theme.spacing(2),
  borderRadius: "50%",
}));

export const ContentBox = styled(Box)(({ theme: { spacing } }) => ({
  padding: spacing(3),
  "& .MuiTypography-body2": {
    color: "#00000080",
    maxWidth: 630,
    marginTop: spacing(1.5),
  },
}));

export const ImageBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  display: "flex",
  flex: 1,
  alignItems: "flex-start",
  justifyContent: "center",
  [theme.breakpoints.up("lg")]: {
    paddingRight: theme.spacing(12),
    paddingBottom: theme.spacing(2),
    justifyContent: "flex-end",
  },
}));
